import React, { memo, useEffect, useState } from "react";

// Classnames
import clsx from "clsx";

// Components
import Img from "components/Img";

interface interfaceScrollButton {
  label?: string;
}

const ScrollButton: React.FC<interfaceScrollButton> = memo(() => {
  const [scrollPosition, setScrollPosition] = useState<number>(0);

  const handleScroll = () => {
    const position = window.pageYOffset;

    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => {
    let numb;
    const height = document.body.offsetHeight;

    if (scrollPosition > 200) {
      numb = 0;
    } else {
      numb = height;
    }

    window.scroll({
      top: numb,
      left: 0,
      behavior: "smooth"
    });
  };

  const cnImg = clsx(
    "scroll-button__img flex flex-ai-center flex-jc-center",
    scrollPosition > 200 ? "scroll-button__img--active" : ""
  );

  return (
    <button
      type="button"
      onClick={handleClick}
      className="scroll-button"
    >
      <Img isSvg alt="Arrow" name="arrowSvg" className={cnImg} />
      {/*{label || `${scrollPosition > 200 ? "Top" : "Bottom"}`}*/}
    </button>
  );
});

export default ScrollButton;